import { OTHERWORLD_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/otherworldBackdrops';
import { stoneBiome } from '../biomeArchetypes';
import { ATMOSPHERE_PALETTE as P } from '../palette';

/** Petrified / Stoneveil Barrens — a stone-dead petrified forest: a wan overcast sky under a dim
 *  pale dead sun, drifting stone dust (no ember warmth), thin colourless light-shafts, a faintly
 *  breathing pale dust-bloom, a drained dust light-bed, slow settling dust on a faint wind, a barely
 *  guttering dust shimmer, fossilized petrified tree silhouettes (STONE-toned spires + trunks, not
 *  charred black), low brown-gray dust haze, and a DESATURATED stone grade. Ancient + lifeless +
 *  dead-still — distinct from ashlands (charcoal gray with surviving ORANGE embers): here it is
 *  fossilized BROWN-GRAY STONE, all warmth drained, only pale dust survives. Contrast kept (no wash). */
export const PETRIFIED = stoneBiome({
  id: 'petrified',
  sky: { from: 0x42403c, to: 0x9c9082 },
  celestial: { atX: 0.5, atY: 0.2, color: 0xd8c9b0, haloColor: 0xe4d8c0, size: 84, haloScale: 2.8, coreAlpha: 0.48, haloAlpha: 0.13 },
  motes: { colors: [P.bone, 0xc9bca4, 0xa89d8a], count: 16, sizeMin: 4, sizeMax: 11, driftPx: 30, periodMinMs: 7000, periodMaxMs: 15000, alphaMin: 0.1, alphaMax: 0.42 },
  rays: { color: P.bone, count: 3, widthMin: 70, widthMax: 150, height: 520, tiltDeg: 6, periodMinMs: 9000, periodMaxMs: 16000, alphaMin: 0.06, alphaMax: 0.22 },
  glow: {
    blobs: [
      { color: 0xd8c9b0, atX: 0.5, atY: 0.16, size: 460, alpha: 0.07 },
      { color: 0xa89d8a, atX: 0.5, atY: 0.97, size: 580, alpha: 0.06 },
    ],
    breathe: { periodMs: 8000, min: 0.9, max: 1.12 },
  },
  lightField: { palette: [0xc9bca4, P.bone, 0xa89d8a], count: 11, sizeMin: 120, sizeMax: 300, alphaMin: 0.03, alphaMax: 0.11, driftRadius: 50, periodMinMs: 8000, periodMaxMs: 15000 },
  weather: { mode: 'fall', color: 0xc4b69c, colorEnd: 0x8c8170,
    size: 6, frequencyMs: 130, lifespanMs: 5200, speed: 12, gravityY: 5, windX: 26, alphaEnd: 0.45,
    gust: { periodMs: 9000, min: 0.5, max: 1.35, phase: 0.3 } },
  flicker: { color: 0xc9bca4, size: 280, baseAlpha: 0.04, flickerAmp: 0.03, hzMin: 1, hzMax: 4, anchors: [{ atX: 0.22, atY: 0.92 }, { atX: 0.55, atY: 0.95 }, { atX: 0.8, atY: 0.92 }] },
  parallax: [
    { svg: OTHERWORLD_BACKDROPS.petrified.far, shape: 'spires', color: 0x6f665a, speed: 0.04, height: 440, alpha: 0.7, detail: 0.9, sway: { ampPx: 6, periodMs: 34000 } },
    { svg: OTHERWORLD_BACKDROPS.petrified.mid, shape: 'columns', color: 0x564e44, speed: 0.1, height: 300, alpha: 0.84, detail: 1.1 },
    { svg: OTHERWORLD_BACKDROPS.petrified.near, shape: 'columns', color: 0x3c352e, speed: 0.18, height: 190, alpha: 0.94, detail: 1 },
  ],
  fog: { color: 0xb3a78f, bands: 5, alphaMin: 0.04, alphaMax: 0.11, driftPx: 45, periodMinMs: 10000, periodMaxMs: 17000 },
  closer: {
    vignette: { color: 0x2e2a26, edgeAlpha: 0.32, washColor: 0xb8a988, washAlpha: 0.04 },
    grade: { top: 0xb0a48c, bottom: 0x6a6155, strength: 0.1, blend: 'normal' },
  },
});
